<template>
    <el-dialog
            title="选择数据项"
            :close-on-click-modal="false"
            :visible.sync="visible">
        <el-table
                :data="dataList"
                row-key="id"
                border
                stripe
                @selection-change="selectionChangeHandle"
                v-loading="dataListLoading"
                style="width: 100%"
        >
            <el-table-column type="selection" fixed width="55"></el-table-column>
            <el-table-column
                    fixed
                    type="index"
                    header-align="left"
                    align="left"
                    label="序号"
                    width="60"
                    :index="getRowsIndex"
            >
            </el-table-column>
            <el-table-column
                    fixed
                    prop="datasetCode"
                    header-align="left"
                    align="left"
                    label="数据集编号"
            >
            </el-table-column>
            <el-table-column
                    fixed
                    prop="columnName"
                    header-align="left"
                    align="left"
                    label="字段名称"
            >
            </el-table-column>
            <el-table-column
                    prop="displayName"
                    header-align="left"
                    align="left"
                    label="显示名称"
            >
            </el-table-column>
        </el-table>
        <el-pagination
                @size-change="sizeChangeHandle"
                @current-change="currentChangeHandle"
                :current-page="pageIndex"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="pageSize"
                :total="totalCount"
                layout="total, sizes, prev, pager, next, jumper"
        >
        </el-pagination>
        <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
    </el-dialog>
</template>

<script>
    export default {
        props: ['mainContentViewHeight'],
        data() {
            return {
                groupInfo: {},
                visible: false,
                dataList: [],
                dataListLoading: false,
                dataListSelections: [],
                addOrUpdateVisible: false,
                datasetList: [],
                pageIndex: 1,
                pageSize: 10,
                totalCount: 0,
            }
        },
        methods: {
            // 多选
            selectionChangeHandle(val) {
                this.dataListSelections = val;
            },
            getRowsIndex(index) {
                return (this.pageIndex - 1) * this.pageSize + index + 1;
            },
            // 每页数
            sizeChangeHandle(val) {
                this.pageSize = val;
                this.pageIndex = 1;
                this.getDataList();
            },
            // 当前页
            currentChangeHandle(val) {
                this.pageIndex = val;
                this.getDataList();
            },
            // 获取数据列表
            getDataList() {
                this.dataListLoading = true;
                this.$httpReq({
                    url: "/customform/fromdatasetfield/list",
                    method: "post",
                    baseURL:  process.env.VUE_APP_proxybaseurl + '',
                    data: {
                        filter: {
                            formId: this.groupInfo.formId,
                            actionType: 1
                        },
                        page: this.pageIndex,
                        rows: this.pageSize,
                    },
                }).then(({data}) => {
                    if (data) {
                        this.dataList = data.rows;
                        this.totalCount = data.total;
                        this.pageIndex = data.pageIndex;
                    } else {
                        this.dataList = [];
                        this.totalCount = 0;
                        this.pageIndex = 1;
                    }
                    this.dataListLoading = false;
                });
            },
            init(groupInto) {
                this.groupInfo = groupInto || {}
                this.visible = true
                this.getDataList()
            },
            // 表单提交
            dataFormSubmit() {
                let groupId = this.groupInfo.id
                let idList = []
                let length = this.dataListSelections.length;
                if (length == 0) {
                    this.$message.error('请选择数据项')
                    return;
                }
                for (var i = 0; i < length; i++) {
                    let it = this.dataListSelections[i];
                    idList.push(it.id)
                }
                this.$httpReq({
                    url: '/customform/fromdatasetfield/batchGroup/' + groupId,
                    method: 'post',
                    baseURL:  process.env.VUE_APP_proxybaseurl + '',
                    data: idList
                }).then(({data}) => {
                    if (data && data.code === '1') {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 1500,
                            onClose: () => {
                                this.visible = false
                                this.$emit('refreshDataList')
                            }
                        })
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            }
        }
    }
</script>
